<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-users"
        title="Polizeidienststelle"
        @save="savePoliceStationFormData">
        <template v-if="formContext.permissions.canCreateRetroactiveChangesNote === true" v-slot:after-icons>
            <csp-retroactive-changes-modal :record-id="recordId" title="Polizeidienststelle">
            </csp-retroactive-changes-modal>
        </template>
        <div v-if="showChangelogButton" class="float-right">
            <csp-changelog-modal :changelog-url="policeStationChangelogUrl"/>
        </div>
        <h2>Stammdaten</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Tagebuchnummer/AZ"
                property="cargo"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Anrede"
                property="gender"
                :required="true"
                type="radio"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Dienstgrad"
                property="title"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :label="personLabelPrefix + 'Vorname'"
                property="firstName"
                :required="!isGenderCompany"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :label="personLabelPrefix + 'Nachname'"
                property="lastName"
                :required="!isGenderCompany"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Polizeidienststelle"
                property="companyName"
                :required="isGenderCompany"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Straße"
                property="street"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="PLZ"
                property="postalCode"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Ort"
                property="place"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Land"
                :options-loader="loadCountryOptions"
                property="country"
                type="autocomplete"/>
        </b-row>
        <hr>
        <h2>Kontaktdaten</h2>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Mobil"
                property="phone"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Telefon"
                property="mobile"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="E-Mail"
                property="email"
                type="text"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    const container = Container.getInstance();
    import FormDataMixin from '../../mixins/FormDataMixin';
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'ParticipantPoliceStation',
        mixins: [FormDataMixin],
        computed: {
            policeStationChangelogUrl() {
                return '/api/desktop/records/' + this.recordId + '/participants/police-station/changelog';
            },
            isGenderCompany() {
                return this.formContext.form.getProperty('gender') === 'company';
            },
            personLabelPrefix() {
                if (this.isGenderCompany) {
                    return 'Ansprechpartner ';
                }

                return '';
            },
            recordId() {
                return parseInt(this.$route.params.recordId);
            },
            showChangelogButton() {
                return this.formContext.data.isEntityNew === false
                    && !this.formContext.isInEditMode
                    && this.formContext.permissions.showChangelog === true;
            },
        },
        methods: {
            loadCountryOptions() {
                return recordRepository.loadLegacySelectOptions('countries')
            },
            savePoliceStationFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveParticipantsPoliceStation(this.recordId, postData)
                }
                this.saveFormData(formContext, saveFunction, null);
            },
        },
    }
</script>
